import dayjs from "dayjs";
import { CURRENCY_META } from "@/lib/i18n";

// Prices are stored in ZAR. PrefsProvider configures display currency + live rates.
let money = { currency: "ZAR", rates: { ZAR: 1 } };
export const configureMoney = (currency, rates) => {
  money = { currency, rates: { ZAR: 1, ...rates } };
};
export const currentCurrency = () => money.currency;

export const formatZAR = (n) => `R${Math.round(Number(n ?? 0)).toLocaleString("en-ZA")}`;

export const formatR = (n) => {
  const zar = Number(n ?? 0);
  if (money.currency === "ZAR") return formatZAR(zar);
  const meta = CURRENCY_META.find((c) => c.key === money.currency);
  const rate = money.rates[money.currency] ?? 1;
  const v = zar * rate;
  const txt = v.toLocaleString("en-US", { minimumFractionDigits: meta.decimals, maximumFractionDigits: meta.decimals });
  return `${meta.symbol}${txt}`;
};

export const formatTime = (iso) => dayjs(iso).format("HH:mm");
export const formatDay = (iso) => {
  const d = dayjs(iso);
  if (d.isSame(dayjs(), "day")) return "Today";
  if (d.isSame(dayjs().add(1, "day"), "day")) return "Tomorrow";
  return d.format("ddd, D MMM");
};
export const formatDateLong = (iso) => dayjs(iso).format("dddd, D MMMM");
export const formatDayTime = (iso) => `${formatDay(iso)} · ${formatTime(iso)}`;

export const minutesUntil = (iso) => dayjs(iso).diff(dayjs(), "minute");
export const canJoin = (iso, durationMin) => {
  const m = minutesUntil(iso);
  return m <= 10 && m > -durationMin;
};
export const isPast = (iso, durationMin) => minutesUntil(iso) <= -durationMin;

export const LEVEL_LABEL = { beginner: "Beginner", intermediate: "Intermediate", advanced: "Advanced", all: "All levels" };
